import React, { useState } from 'react';
import { authService } from '../../services/authService';
import './RegisterForm.css';

const RegisterForm = ({ onRegister, onSwitchToLogin }) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);

    try {
      // Отправляем данные в формате, который ожидает сервер
      const response = await authService.register({
        username: formData.username,
        email: formData.email,
        password: formData.password,
        confirmPassword: formData.confirmPassword,
        firstName: formData.firstName,
        lastName: formData.lastName
      });
      onRegister(response.user);
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка при регистрации');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <h2 className="register-title">Форма регистрации</h2>

        <form onSubmit={handleSubmit}>
          <div className="register-form-group">
            <label className="register-form-label">
              Имя пользователя
            </label>
            <input
              type="text"
              name="username"
              value={formData.username}
              onChange={handleChange}
              placeholder="Введите имя пользователя"
              className="register-form-input"
              required
            />
          </div>

          

          <div className="register-form-group">
            <label className="register-form-label">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="email@example.com"
              className="register-form-input"
              required
            />
          </div>

          <div className="register-form-group">
            <label className="register-form-label">
              Пароль
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              className="register-form-input"
              required
            />
          </div>

          <div className="register-form-group">
            <label className="register-form-label">
              Подтверждение пароля
            </label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="••••••••"
              className="register-form-input"
              required
            />
          </div>

          {error && (
            <div className="register-form-error">{error}</div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="register-form-button"
          >
            {loading ? 'Регистрация...' : 'Зарегистрировать'}
          </button>
        </form>

        <div className="register-form-footer">
          <button 
            onClick={onSwitchToLogin}
            className="register-form-footer-link"
          >
            Уже есть аккаунт? Войти
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;